import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopupsInfo } from '../../tools/page-login-popups/models/popups-info.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit , OnChanges{
  @Input() display_dialog_info = false; 
  @Input() popupsInfo:PopupsInfo;
  @Output() closed :EventEmitter<boolean>  = new EventEmitter<boolean>();
  dialogInfoHtml: string = "";
  safeHtml: SafeHtml;
  constructor(private readonly translate: TranslateService, private sanitizer: DomSanitizer) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.popupsInfo?.content);
  }

  ngOnInit(): void {
    this.loadWordingDialogPremiereConnexion();
  }

  closeDialog(){
    this.closed.emit(true);
  }

  loadWordingDialogPremiereConnexion() {
    this.translate.get('activate_account.dialogInfo_content').subscribe((value: string) => {
      this.dialogInfoHtml = value;
    });
  }

}
